const search = () => {
  const buttons = document.querySelectorAll('.js-site-search-toggle')
  const overlayEl = document.getElementById('js-site-overlay')
  const mobileSearchEl = document.getElementById('js-mobile-search-wrapper')

  if (!buttons?.length) return

  const toggle = () => {
    overlayEl.classList.toggle('invisible')
    mobileSearchEl.classList.toggle('hidden')

    if (!mobileSearchEl.classList.contains('hidden')) {
      document.getElementById('js-mobile-search-input').focus()
    }
  }

  // click action
  buttons.forEach((button) => button.addEventListener('click', () => toggle()))
}

export default search
